import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { getLoginToken } from "../storage";
import { queryKeys } from "../react-query/constants";
import { successAlert, toastOptions } from "../utils";
import { toast } from "react-toastify";

const SERVER_ERROR = "There was an error contacting the server.";

async function createBlog(formData: any) {
  const data = await axiosInstance({
    url: "/blog",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useCreateBlog() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => createBlog(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.blog]);
      successAlert("Blog created successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function allBlog() {
  const data = await axiosInstance({
    url: "/blog",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useGetBlog() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.blog],
    queryFn: allBlog,
  });
  return data;
}

async function updateBlog(formData: any) {
  const data = await axiosInstance({
    url: `/blog/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useUpdateBlog() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData: any) => updateBlog(formData),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries([queryKeys.user]);
      successAlert("Blog updated successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function deleteBlog(blogId: string) {
  const data = await axiosInstance({
    url: `/blog/${blogId}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useDeleteBlog() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => deleteBlog(formData as any),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.blog]);
      successAlert("Blog deleted successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}
